"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var uuid_1 = require("uuid");
var GlobalState = /** @class */ (function () {
    /**
     * Initial state is *NOT* mutation-safe!
     */
    function GlobalState(initialState, stateDidUpdate) {
        this._state = initialState;
        this._reactContext = React.createContext(initialState);
        this._refreshProviderCollection = {};
        this._stateDidUpdate = stateDidUpdate;
    }
    Object.defineProperty(GlobalState.prototype, "state", {
        /**
         * State is *NOT* mutation-safe!
         */
        get: function () {
            return this._state;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalState.prototype, "ContextConsumer", {
        get: function () {
            return this._reactContext.Consumer;
        },
        enumerable: false,
        configurable: true
    });
    GlobalState.prototype.withProvider = function (Component) {
        var _this = this;
        var providerWrapperId = (0, uuid_1.v4)();
        return React.forwardRef(function (props, ref) {
            var _a = React.useState(0), stateKey = _a[0], updateStateKey = _a[1];
            var stateUpdateResolvers = React.useRef([]);
            React.useEffect(function () {
                stateUpdateResolvers.current.forEach(function (resolve) { return resolve(); });
                stateUpdateResolvers.current = [];
                _this._refreshProviderCollection[providerWrapperId] = function () { return new Promise(function (resolve) {
                    stateUpdateResolvers.current.push(resolve);
                    updateStateKey(stateKey + 1);
                }); };
                return function () {
                    delete _this._refreshProviderCollection[providerWrapperId];
                };
            }, [stateKey]);
            var Provider = _this._reactContext.Provider;
            return (React.createElement(Provider, { value: _this._state },
                React.createElement(Component, __assign({}, props, { ref: ref }))));
        });
    };
    GlobalState.prototype.withState = function (Component) {
        var Consumer = this._reactContext.Consumer;
        return React.forwardRef(function (props, ref) { return (React.createElement(Consumer, null, function (state) { return React.createElement(Component, __assign({}, state, props, { ref: ref })); })); });
    };
    GlobalState.prototype.updateState = function (stateUpdate) {
        return __awaiter(this, void 0, void 0, function () {
            var prevState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        prevState = this._state;
                        if (typeof stateUpdate === "function") {
                            this._state = stateUpdate(this._state);
                        }
                        else {
                            this._state = __assign(__assign({}, this._state), stateUpdate);
                        }
                        return [4 /*yield*/, Promise.all(Object.values(this._refreshProviderCollection).map(function (refreshProvider) { return refreshProvider(); }))];
                    case 1:
                        _a.sent();
                        if (this._stateDidUpdate) {
                            this._stateDidUpdate(prevState);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return GlobalState;
}());
exports.default = GlobalState;
